import { DESIGN_TOKENS } from './designTokens';

export const MOTION_TOKENS = Object.freeze({
  feedback: { duration: DESIGN_TOKENS.duration.feedback / 1000, ease: DESIGN_TOKENS.ease.premium },
  component: { duration: DESIGN_TOKENS.duration.component / 1000, ease: DESIGN_TOKENS.ease.premium },
  reveal: { duration: DESIGN_TOKENS.duration.route / 1000, ease: DESIGN_TOKENS.ease.premium },
  showcase: { duration: 0.8, ease: DESIGN_TOKENS.ease.premium },
  ambient: { duration: 10, ease: 'easeInOut', repeat: Infinity, repeatType: 'mirror' },
  stagger: 0.085,
});

export const PREMIUM_EASE = DESIGN_TOKENS.ease.premium;

export const premiumReveal = {
  hidden: { opacity: 0, y: 28, filter: 'blur(7px)' },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: MOTION_TOKENS.showcase,
  },
};

export const revealUp = {
  hidden: { opacity: 0, y: 14 },
  visible: { opacity: 1, y: 0 },
};

export const revealContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: MOTION_TOKENS.stagger,
    },
  },
};
